module.exports = "/virtual-football-league/img/amblems/right/Spain/Fake_RealMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Spain/Fake_RealMadrid.png
// module id = 2151
// module chunks = 4